// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import cn from 'classnames';
import get from 'lodash4/get.js';
import cloneDeep from 'lodash4/cloneDeep.js';
import {Icon} from '../icon';
import * as cns from './table.module.less';

const get_sort = (val, negative)=>(a, b)=>{
    const mult = negative ? -1 : 1;
    let v1 = val ? get(a, val) : a;
    let v2 = val ? get(b, val) : b;
    v1 = typeof v1 == 'string' ? v1.toLowerCase() : v1;
    v2 = typeof v2 == 'string' ? v2.toLowerCase() : v2;
    return v1 > v2 ? 1*mult : -1*mult;
};

export const do_sort = (_trs, sorting)=>{
    if (!sorting)
        return _trs;
    const trs = cloneDeep(_trs);
    const [field, direction] = sorting.split('@');
    let sort_fn = get_sort(field, direction=='91');
    if (sort_fn)
        trs.sort(sort_fn);
    return trs;
};

export const get_ico = (field, sorting)=>{
    if (!field||!sorting)
        return null;
    if (sorting!=`${field}@19` && sorting!=`${field}@91`)
        return null;
    return <Icon className={cn(cns.sorting_icon,
      sorting==`${field}@19`&&cns.sorting_icon__negative)}
      name="ico_arrow_up" size="xxs" color="primary"/>;
};
